import { observer } from 'mobx-react-lite';
import React from 'react';
import { formatCurrency } from '#/lib/currency';
import { formatUnitTitle } from '#/lib/formatUnitTitle';
import { FleetCategory } from '@jucy/rentals-api-client/rentals-api-v3/models/FleetCategory';
import { ProductType } from '@jucy/rentals-api-client/rentals-api/models/ProductType';
import Box from '@mui/material/Box';
import BookingSummaryPanelRow from './BookingSummaryPanelRow';

export type FleetCategorySummaryRowProps = {
    fleetCategory: FleetCategory;
    amendedFleetCategory?: FleetCategory;
};

export const FleetCategorySummaryRowComponent: React.FC<FleetCategorySummaryRowProps> = ({ fleetCategory }) => {
    const { unitTitle } = formatUnitTitle({
        type: ProductType.Daily,
        price: fleetCategory?.dailyRate,
        rentalDays: fleetCategory?.rentalDays,
    });
    return (
        <BookingSummaryPanelRow
            title={fleetCategory?.name}
            subTitle={unitTitle}
            value={formatCurrency(fleetCategory?.total.value || 0, fleetCategory?.total.currencyCode)}
        />
    );
};

export const FleetCategorySummaryRow: React.FC<FleetCategorySummaryRowProps> = observer(function FleetCategorySummaryRowObservedComponent({
    fleetCategory,
    amendedFleetCategory,
}) {
    const categoryCodeChanged = fleetCategory.categoryCode !== amendedFleetCategory?.categoryCode;
    const rentalDaysChanged = fleetCategory.rentalDays !== amendedFleetCategory?.rentalDays;
    const dailyRateChanged = fleetCategory.dailyRate.value !== amendedFleetCategory?.dailyRate.value;
    const totalChanged = fleetCategory.total.value !== amendedFleetCategory?.total.value;
    const hasAmendment = Boolean(amendedFleetCategory && (categoryCodeChanged || rentalDaysChanged || dailyRateChanged || totalChanged));

    const originalFleetCatRow = <FleetCategorySummaryRowComponent fleetCategory={fleetCategory} />;

    if (!hasAmendment || !amendedFleetCategory) {
        return originalFleetCatRow;
    }

    return (
        <>
            <Box component="span" sx={{ textDecoration: 'line-through' }}>
                {originalFleetCatRow}
            </Box>
            <FleetCategorySummaryRowComponent fleetCategory={amendedFleetCategory} />
        </>
    );
});
